import { call, put, takeEvery, all } from 'redux-saga/effects';
import InstitutionApi from '../../api/InstitutionApi';
import * as Actions from '../actions/institutionsActions';
import * as Types from '../actions/institutionsActionTypes';

function* updateInstitution(action) {
  try {
    const response = yield call(InstitutionApi.updateInstitution, action.data);
    console.info(response);
    yield put(Actions.updateInstitutionSuccess(response));
    yield call(action.onSuccess);
  } catch (error) {
    console.info(error);
    yield put(Actions.updateInstitutionFailure(error));
    yield call(action.onFail, error);
  }
}

export default function* institutionFlow() {
  yield all([
    takeEvery(Types.UPDATE_INSTITUTION, updateInstitution),
  ]);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/institutionFlow.js